class MapBoxElement extends HTMLElement {
  pin = `<svg xmlns="http://www.w3.org/2000/svg" width="43.507" height="29.326" viewBox="0 0 43.507 29.326">
  <defs>
    <clipPath id="a">
      <rect data-name="Rectangle 44" width="43.507" height="29.326" fill="#ee7070"/>
    </clipPath>
  </defs>
  <g data-name="Groupe 1246">
    <g data-name="Groupe 11" clip-path="url(#a)">
      <path d="M42.992 3.647C40.626-.79 20.984.067 20.984.067 1.755.718-1.38 3.765.454 9.09s9.406 13.9 11.477 15.619 6.745 7.751 13.49 2.544 11.3-9.7 14.554-14.436 4.26-6.627 3.017-9.171" fill="#ee7070"/>
    </g>
    <path data-name="Icon metro-shop" d="m17.538 9.35.86-5.707h-4.472l-1.87 4.892a1.715 1.715 0 0 0-.088.544c0 1.2 1.25 2.174 2.795 2.174a2.652 2.652 0 0 0 2.774-1.9Zm4.215 1.9c1.544 0 2.795-.974 2.795-2.174 0-.045 0-.089-.005-.132l-.553-5.3h-4.473l-.554 5.3v.136c0 1.2 1.251 2.174 2.795 2.174Zm5.435 1.137v4.3H16.317v-4.29a4.574 4.574 0 0 1-1.553.27 4.482 4.482 0 0 1-.621-.053v6.9a1.525 1.525 0 0 0 1.52 1.522h12.178a1.527 1.527 0 0 0 1.522-1.52v-6.9a4.671 4.671 0 0 1-.621.053 4.517 4.517 0 0 1-1.554-.279Zm4.261-3.855-1.87-4.889h-4.471l.859 5.7a2.645 2.645 0 0 0 2.775 1.911c1.544 0 2.795-.974 2.795-2.174a1.746 1.746 0 0 0-.087-.544Z" fill="#fff"/>
  </g>
</svg>`;

  center = [4.4699, 50.5039];
  initialZoom = 7;

  constructor() {
    super();
  }

  connectedCallback() {
    this.elementId = this.getAttribute('id') || 'map';
    this.searchShop = document.querySelector('mca-search-shop');
    this.initMapbox();
  }

  initMapbox() {
    mapboxgl.accessToken =
      'pk.eyJ1IjoibWNhcm5vbGRzIiwiYSI6ImNscHYyaHR6MjAxZWUyaW85cHBlMW1raTYifQ.gqRjJq1HeDQvxvv6Q9ogwg';
    this.map = new mapboxgl.Map({
      container: this.elementId,
      style: 'mapbox://styles/mcarnolds/cm0wfpdgt00wq01qo76d18bvq/draft',
      center: this.center,
      zoom: this.initialZoom,
    });
    this.querySelector('.mapboxgl-ctrl-attrib-inner').style.display = 'none';
  }

  createMarkers(data) {
    data.forEach((shop) => {
      if (shop.coord && shop.coord.lat && shop.coord.lng) {
        const div = document.createElement('div');
        div.innerHTML = this.pin;
        const marker = new mapboxgl.Marker({ element: div })
          .setLngLat([shop.coord.lng, shop.coord.lat])
          .setPopup(
            new mapboxgl.Popup({ offset: 25, anchor: 'top' }).setHTML(
              `
            <main>
              <h3 style="margin: 0;" class="title">
                ${shop.name}
              </h3>
              <div class="address">
                <span><strong>Address :</strong></span>
                <a href="${shop.url}" target="_blank">${shop.street} ${shop.street_number}, ${shop.postal_code} ${shop.city}</a>
              </div>
              <div class="phone">
                <span><strong>Phone :</strong></span>
                <a href="${shop.phone}" target="_blank">${shop.phone}</a>
              </div>
            </main>
            `
            )
          )
          .addTo(this.map);

        marker.getElement().addEventListener('click', () => {
          this.zoomToMarker(shop.coord.lat, shop.coord.lng, 15);
          this.searchShop.showDetail(shop);
        });
      }
    });

    this.setBounds(data);

    // if (data.length === 1) {
    //   this.zoomToMarker(data[0].coord.lat, data[0].coord.lng);
    // }
  }

  zoomToMarker(lat, lng, zoom = this.initialZoom) {
    if (!lat || !lng) return;
    this.map.flyTo({ center: [lng, lat], zoom: zoom });
  }

  zoomToMarkers() {
    this.map.fitBounds(this.bounds, { padding: 150 });
  }

  resetZoom() {
    this.map.flyTo({ center: this.center, zoom: 7 });
  }

  removeMarkers() {
    const markers = document.querySelectorAll('.mapboxgl-marker');
    markers.forEach((marker) => marker.remove());

    this.resetZoom();
  }

  setBounds(data) {
    this.bounds = new mapboxgl.LngLatBounds();
    data.forEach((shop) => {
      if (!shop.coord) return;
      this.bounds.extend([shop.coord.lng, shop.coord.lat]);
    });
  }
}

if (!customElements.get('mca-map')) {
  customElements.define('mca-map', MapBoxElement);
}
